import { useCallback } from 'react'

import { eventService } from 'services/analytics/event_service'

export const useTrack = () => useCallback((config) => {
  const {
    name,
    properties = {},
    version = 1,
    entities = ['attribution', 'organization', 'user'],
    dependencies = {},
  } = config

  eventService.dispatch({
    name,
    version,
    dependencies,
    entities,
    properties,
  })
}, [])
